import { MultiSelect } from "primereact/multiselect";

export default function CustomMultiSelect({
  name,
  value,
  callback,
  filter,
  options,
  placeholder = "",
  className = "",
  appendTo = "self",
  panelClassName = "",
  // Optional: pass "name"/"code" for {name, code} options (default keeps the
  // PrimeReact {label, value} behaviour existing callers rely on).
  optionLabel,
  optionValue,
}) {
  const handleChange = (e) => {
    callback && callback(e);
  };

  return (
    <MultiSelect
      appendTo={appendTo}
      name={name}
      filter={filter}
      value={value}
      onChange={handleChange}
      options={options}
      optionLabel={optionLabel}
      optionValue={optionValue}
      placeholder={placeholder}
      emptyFilterMessage={"Aucun résultat trouvé"}
      className={className}
      panelClassName={panelClassName}
    />
  );
}
